import gqlRequest from 'graphql/generic';
import { OrderNotesTypes } from '../types';

type createOrderNoteReturn = {
  createOrderNote: {
    notes: OrderNotesTypes[];
  };
};

const createOrderNote = `
  mutation CreateOrderNote($id: ID!, $content: String!, $critical: Boolean!) {
    createOrderNote(_id: $id, content: $content, critical: $critical) {
      _id
      notes {
        _id
        content
        created
        critical
        name
        party_id
        resolved
      }
    }
  }
`;

type createOrderNoteParams = {
  id: string;
  content: string;
  critical: boolean;
};

export const mutationCreateOrderNote = (params: createOrderNoteParams) =>
  gqlRequest<createOrderNoteReturn, createOrderNoteParams>(createOrderNote, params);

type updateOrderNoteReturn = {
  updateOrderNote: {
    notes: OrderNotesTypes[];
  };
};

const updateOrderNote = `
  mutation UpdateOrderNote($id: ID!, $noteId: ID!, $content: String!, $critical: Boolean!, $resolved: Boolean!) {
    updateOrderNote(_id: $id, note_id: $noteId, content: $content, critical: $critical, resolved: $resolved) {
      _id
      notes {
        _id
        content
        created
        critical
        name
        party_id
        resolved
      }
    }
  }
`;

type updateOrderNoteParams = {
  id: string;
  content: string;
  critical: boolean;
  noteId: string;
  resolved: boolean;
};

export const mutationUpdateOrderNote = (params: updateOrderNoteParams) =>
  gqlRequest<updateOrderNoteReturn, updateOrderNoteParams>(updateOrderNote, params);

type deleteOrderNoteReturn = {
  deleteOrderNote: {
    notes: OrderNotesTypes[];
  };
};

const deleteOrderNote = `
  mutation DeleteOrderNote($id: ID!, $noteId: ID!) {
    deleteOrderNote(_id: $id, note_id: $noteId) {
      _id
      notes {
        _id
        content
        created
        critical
        name
        party_id
        resolved
      }
    }
  }
`;

type deleteOrderNoteParams = {
  id: string;
  noteId: string;
};

export const deleteUpdateOrderNote = (params: deleteOrderNoteParams) =>
  gqlRequest<deleteOrderNoteReturn, deleteOrderNoteParams>(deleteOrderNote, params);
